import { render, staticRenderFns } from "./SolutionsGoalsSummary.vue?vue&type=template&id=2a03605a&scoped=true&"
import script from "./SolutionsGoalsSummary.vue?vue&type=script&lang=js&"
export * from "./SolutionsGoalsSummary.vue?vue&type=script&lang=js&"
import style0 from "./SolutionsGoalsSummary.vue?vue&type=style&index=0&id=2a03605a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a03605a",
  null
  
)

export default component.exports
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QBtn,QScrollArea});
